window.dataLayer = window.dataLayer || [];
const { dataLayer } = window;

export const setRXDimension = rxNumber => {
  dataLayer.push({ 'Rx Number': rxNumber });
};

export const setOrderIdDimension = orderId => {
  dataLayer.push({ 'Order Id': orderId });
};

export const setOtherGADimension = ({
  practiceId,
  practiceGuid,
  practiceName,
  pharmacyType,
  parentProductName,
  brand,
  childSKU,
  productPrice,
  shippingCost,
  tax,
  orderTotal,
  nbrofCardsonFile,
  prescriptionId,
}) => {
  dataLayer.push({
    'Prescription Id': `${prescriptionId}`,
    'Practice Id': `${practiceId}`,
    'Practice Guid': practiceGuid,
    'Practice Name': practiceName,
    'Pharmacy Type': pharmacyType,
    'Parent Product Name': parentProductName,
    Brand: brand,
    'Child SKU': childSKU,
    'Product Price': `${productPrice}`,
    'Shipping Cost': `${shippingCost}`,
    Tax: `${tax}`,
    'Order Total': `${orderTotal}`,
    'Nbr of Cards on File': `${nbrofCardsonFile}`,
  });
};



// WEBPACK FOOTER //
// ./src/gtmMetrics.js